/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Woodlowlevel2Inputs */



/**
* | output |
* | --- |
* | "Low wood level" |
*
* @param {Br_History_Key_Woodlowlevel2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_woodlowlevel2 = /** @type {((inputs?: Br_History_Key_Woodlowlevel2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Woodlowlevel2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Low wood level")
	return /** @type {LocalizedString} */ ("Niveau de bois bas")
});
export { br_history_key_woodlowlevel2 as "br_history_key_woodLowLevel" }